import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

const filter = {
	VozzavtypPzn: null as number | null,
	Text: null as string | null,
	TextPfxPrp: null as boolean | null,
	TextPrp: null as boolean | null,
	TextSfxPrp: null as boolean | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupPracOsobniCis: null as string | null,
	VstupDatOd: null as Date | null,
	VstupDatDo: null as Date | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VozzavtypPzn: [] },
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {
		[types.mutations.ODLOZENA_CINNOST_PRACOVNIK_SELECT_MAPPER](state, { data, mode }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
